<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <h4 class="header-title mt-0 mb-1">{{ $t('currency.form.information') }}</h4>
          <p class="sub-header"></p>

          <div class="row">

            <div class="col-md-12">
              <TextField 
                :placeholder="$t('currency.form.symbol.placeholder')"
                :label="$t('currency.form.symbol.label')"
                v-model="model.symbol"
                :error="$v.model.symbol.$error"
                :errorMessage="$v.model.symbol.errorMessage"
              />
            </div>

            <div class="col-md-12">
              <TextField 
                :placeholder="$t('currency.form.code.placeholder')"
                :label="$t('currency.form.code.label')"
                v-model="model.code"
                :error="$v.model.code.$error"
                :errorMessage="$v.model.code.errorMessage"
              />
            </div>

            <div class="col-md-12">
              <TextField 
                :placeholder="$t('currency.form.name.placeholder')"
                :label="$t('currency.form.name.label')"
                v-model="model.name"
                :error="$v.model.name.$error"
                :errorMessage="$v.model.name.errorMessage"
              />
            </div>

          </div>

          <div class="row">

            <div class="col-md-12">
              <div class="form-group">
                <div class="textOnInput">
                  <label for="remarks" class="form-label">{{ $t('currency.form.remarks.placeholder') }}</label>
                  <textarea
                    class="form-control" 
                    name="remarks"
                    :placeholder="$t('currency.form.remarks.placeholder')"
                    rows="5"
                    v-model="model.remarks"
                  />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextField from '@components/form2/textfield.vue'
import  FormMixin from '@mixins/form'
import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    TextField
  },
  validations: {
    model:{
      symbol: { required },
      code: { required },
      name: { required }
    }
  },
  mixins: [ FormMixin ],
  data () {
    return {
      model:{
        symbol: '',
        code: '',
        name: '',
        remarks: '',
      },
    }
  }
}
</script>